import { useCallback } from 'react';
import useLocalStorage from './useLocalStorage';

/**
 * useFavorites - 즐겨찾기 관리 커스텀 훅
 * @returns {Object} - 즐겨찾기 관련 함수와 상태
 */
function useFavorites() {
  const [favorites, setFavorites] = useLocalStorage('obituary_favorites', []);

  // 즐겨찾기 여부 확인
  const isFavorite = useCallback((obituaryId) => {
    return favorites.includes(obituaryId);
  }, [favorites]);

  // 즐겨찾기 추가
  const addFavorite = useCallback((obituaryId) => {
    setFavorites(prev => {
      if (prev.includes(obituaryId)) {
        return prev;
      }
      return [...prev, obituaryId];
    });
  }, [setFavorites]);

  // 즐겨찾기 제거
  const removeFavorite = useCallback((obituaryId) => {
    setFavorites(prev => prev.filter(id => id !== obituaryId));
  }, [setFavorites]);

  // 즐겨찾기 토글
  const toggleFavorite = useCallback((obituaryId) => {
    if (isFavorite(obituaryId)) {
      removeFavorite(obituaryId);
      return false; // removed
    } else {
      addFavorite(obituaryId);
      return true; // added
    }
  }, [isFavorite, addFavorite, removeFavorite]);

  // 모든 즐겨찾기 제거
  const clearFavorites = useCallback(() => {
    setFavorites([]);
  }, [setFavorites]);

  // 즐겨찾기 개수
  const favoriteCount = favorites.length;

  return {
    favorites,
    isFavorite,
    addFavorite,
    removeFavorite,
    toggleFavorite,
    clearFavorites,
    favoriteCount,
  };
}

export default useFavorites;
